import React, { useRef, useState, useEffect, useMemo } from 'react'
import FullScreenButton from "../../components/FullScreenButton";
import { formatIndianDate } from "../../utils/Constant";
import { Table, Tabs, Button, Tooltip, Select, message, Spin, Checkbox, Modal } from "antd";
import CustomSearch from '../../components/search/CustomSearch';
import Pnation from '../../components/Pagination/pagination';
import Papa from 'papaparse';
import { DownloadOutlined } from '@ant-design/icons';
import { capitalizeAndRemoveUnderscores, limitWords } from '../../utils/utils';
import axiosInstance from '../../utils/axiosInstance';
import { useSelector } from 'react-redux';
const { TabPane } = Tabs;

export default function ExpiringContracts() {

  const [expireContracts, setExpireContracts] = useState([]);
  const [expireContractsSm, setExpireContractsSm] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const comp_id = useSelector((store) => store.auth.userInfo.company_id);
  const [contract_type, setContractType] = useState('Expiring'); // default contract type
  const [searchKeyword, setSearchKeyword] = useState({ search_keyword: '', contract_type: contract_type, company_id: localStorage.getItem("companyId") || comp_id });
  const [isLoading, setIsloading] = useState(false);
  const fullScreenRef = useRef(null);
  const select = useSelector((state) => state.auth.userInfo);
  const user_role = select.role;
  const [selectedExpireRecord, setSelectedExpireRecord] = useState(null); // record from expiring/expired list
  const [selectedContractId, setSelectedContractId] = useState(null); // record selected in modal
  const [contractList, setContractList] = useState([]); // table data inside modal
  const [contractLoading, setContractLoading] = useState(false); // for modal loading state
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [contractSearchParams, setContractSearchParams] = useState({
    search_keyword: "",
    search_filters: [],
    is_active: "True",
    is_editor: false,
    page_number: 1,
    page_size: 10,
    status: "EXECUTED",
    company_id: localStorage.getItem("companyId") || comp_id,
  });

  const handleLinkExpired = (record) => {
    setSelectedExpireRecord(record);
    setIsModalVisible(true);
    fetchContractList({ ...contractSearchParams, page_number: 1 });
  };

  const fetchContractList = async (params) => {
    setContractSearchParams(params);
    setContractLoading(true);
    try {
      const res = await axiosInstance.post("/contract/get/", params);
      const filteredResults = res.data.results.filter((item) => !item.linked_document_id);
      setContractList({
        ...res.data,
        results: filteredResults,
      });
    } catch (err) {
      message.error("Failed to load contracts");
    } finally {
      setContractLoading(false);
    }
  };

  const handleConfirmLink = async () => {
    if (!selectedContractId || !selectedExpireRecord.document_id || !selectedExpireRecord.id) {
      message.error("Select a contract first.");
      return;
    }
    const payload = {
      expired_document_id: selectedExpireRecord.document_id,
      linked_agreement_id: selectedExpireRecord.id,
      target_id: selectedContractId,
      company_id: localStorage.getItem("companyId") || comp_id,
    };
    try {
      await axiosInstance.post("/dashboard/link-expired-agreement/", payload);
      message.success("Linked successfully.");
      setIsModalVisible(false);
      setSelectedContractId(null);
      setSelectedExpireRecord(null);

      // RE-FETCH updated data
      onPeding(true);
      const res = await axiosInstance.post("/dashboard/to_expire_agreement/", searchKeyword);
      setExpireContracts(res.data?.results || []);
      if (!isFullScreen) {
        setExpireContractsSm((res.data?.results || []).slice(0, 4));
      }
      onPeding(false);
    } catch (err) {
      message.error(err.response?.data?.error || "Failed to link contract.");
    }
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
    setExpireContracts([]);
    setExpireContractsSm([]);
  };

  const topColumns = useMemo(() => [
    {
      title: activeTab == 1 ? "Days Left" : "Elapsed Days",
      dataIndex: "expiry_in_days",
      key: "expiry_in_days",
      render: (text) => {
        return (
          <span className='text-red-600 pl-6'>
            {text}
          </span>
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name_of_client",
      key: "name_of_client",
      ellipsis: true,
      render: (text, re) => <span className='text-red-600 text-center'>{text || ''}</span>,
    },
    {
      title: "Type",
      dataIndex: "agreement_type",
      key: "agreement_type",
      ellipsis: true,
      render: (text, re) => (
        <span className='text-red-600 text-center'>{text ? limitWords(text) : ''}</span>
      ),
    },
    {
      title: "Effective Date",
      dataIndex: "effective_date",
      key: "effective_date",
      ellipsis: true,
      render: (date, re) => (<span className='text-red-600 text-center'>{formatIndianDate(date) || ''} </span>)
    },
    {
      title: "Expiry Date",
      dataIndex: "calculated_expiry_date",
      key: "calculated_expiry_date",
      ellipsis: true,
      render: (date, re) => (<span className='text-red-600 text-center'>{formatIndianDate(date) || ''} </span>)
    },
    ...(user_role === 'agreement controller head' || user_role === 'agreement controller team' || user_role === 'professional'
      ? [{
        title: "Renewed",
        key: "renewed",
        render: (_, record) => (
          <div className='text-left'>
            <Button style={{ textAlign: "left" }} type="link" onClick={() => handleLinkExpired(record)}>
              Link
            </Button>
          </div>
        ),
      }]
      : [])
  ], [expireContracts])

  const onFullScreen = (value) => {
    setIsFullScreen(value)
    if (!value && expireContracts.length) {
      setExpireContractsSm(expireContracts.slice(0, 4));
    }
  }

  const handleSearch = (value) => {
    setSearchKeyword((val) => {
      val.search_keyword = value;
      return { ...val }
    })
  };

  const getData = (data) => {
    setExpireContracts(data);
    if (!isFullScreen) {
      setExpireContractsSm(data.slice(0, 4))
    }
  }

  const onPeding = (val) => {
    setIsloading(val)
  }

  const handleDownloadAll = () => {
    if (!expireContracts.length) {
      message.success('Do not have any to download .')
      return false;
    }
    const csvData = expireContracts?.map(contract => ({
      "User Name": contract.user_name,
      "Date of Raising": formatIndianDate(contract.created_at),
      "Agreement Type": contract.agreement_type,
      "Partner Name": contract.name_of_client,
      "Nature": contract.nature,
      "Status": capitalizeAndRemoveUnderscores(contract.status),
      "Remarks": contract.remarks,
    }));

    const csv = Papa.unparse(csvData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "contracts.csv";
    link.click();
    message.success('Successfully download')
  };

  useEffect(() => {
    setSearchKeyword((val) => {
      val.contract_type = activeTab == 1 ? 'Expiring' : 'Expired';
      setContractType(val.contract_type);
      return { ...val }
    })

  }, [activeTab])

  useEffect(() => {
    // When full screen mode is turned OFF, update the small data view
    if (!isFullScreen && expireContracts.length > 0) {
      setExpireContractsSm(expireContracts.slice(0, 4));
    }
  }, [isFullScreen, expireContracts]);

  const contractModalColumns = [
    {
      title: "",
      width: 50,
      render: (_, record) => (
        <Checkbox
          checked={selectedContractId === record.id}
          onChange={() => setSelectedContractId(record.id)}
        />
      ),
    },
    {
      title: "Agreement_id",
      dataIndex: "document_id",
      key: "document_id",
    },
    {
      title: "Partner Name",
      dataIndex: "name_of_client",
    },
    {
      title: "Agreement Type",
      dataIndex: "agreement_type",
    },

    {
      title: "Nature",
      dataIndex: "nature",
      render: (text) => capitalizeAndRemoveUnderscores(text),
    },
    {
      title: "Effective Date",
      dataIndex: "effective_date",
      key: "effective_date",
      width: 160,
      ellipsis: true,
      render: (text) =>
        text ? new Date(text).toLocaleDateString("en-IN") : "",
    },
  ];

  const finalPlod = useMemo(() => ({
    ...contractSearchParams,
    status: "EXECUTED",
    company_id: localStorage.getItem("companyId") || comp_id,
  }), [contractSearchParams]);

  return (
    <div ref={fullScreenRef} className="w-full md:w-1/2 bg-white dark:bg-[#17153B]  rounded-lg dark:text-white dark:border-white border-[1px] ">
      <Modal
        title="Select Contract to Link"
        open={isModalVisible}
        onOk={handleConfirmLink}
        onCancel={() => {
          setIsModalVisible(false);
          setSelectedContractId(null);
        }}
        okText="Confirm"
        cancelText="Cancel"
        width={1000}
      >
        <Spin spinning={contractLoading}>
          <Table
            rowKey="id"
            dataSource={contractList?.results || []}
            columns={contractModalColumns}
            pagination={false}
            scroll={{ y: 500 }}
            size="small"
            className='text-[12px] [&_.ant-table-cell]:p-1 [&_.ant-table-cell]:text-[12px]'
          />
          <div className="mt-4">
            {contractList?.results?.length > 0 && (
              <Pnation
                onPeding={setContractLoading}
                onCngPage={(results, payloadUsed) => {
                  setContractSearchParams(payloadUsed); // ✅ Keep it in sync
                  setContractList(prev => ({ ...prev, results }));
                }}
                url="/contract/get/"
                plod={finalPlod}
                itmeName="contracts"
              />
            )}
          </div>
        </Spin>
      </Modal>

      <div className="flex px-2 py-2 justify-between rounded-t-lg">
        <div className='flex gap-4 justify-start items-center'>
          <h1
            className="pl-4 font-semibold text-[15px] pt-[1%]"
          >
            {`${contract_type} Contracts`}
          </h1>
          {isFullScreen && <div className="inline-flex pl-2 ">
            <CustomSearch onSearch={handleSearch} />
          </div>}
        </div>

        <FullScreenButton onFullScreen={onFullScreen} targetRef={fullScreenRef} />
      </div>
      <Tabs style={{ paddingLeft: '1.5rem' }} className='abc' activeKey={activeTab} onChange={handleTabChange} defaultActiveKey="1" >
        <TabPane tab="Expiring Contracts" key="1">
        </TabPane>
        <TabPane tab="Expired Contracts" key="2">
        </TabPane>
      </Tabs>
      {isFullScreen && <div className="inline-flex pl-2 ">
        <CustomSearch onSearch={handleSearch} />
      </div>}
      <div className="ml-2 -mt-2">
        <Spin spinning={isLoading} tip="Loading...">
          <Table
            dataSource={isFullScreen ? expireContracts : expireContractsSm}
            columns={topColumns}
            size="small"
            className="overflow-y-scroll border-none text-[12px] [&_.ant-table-cell]:p-1 [&_.ant-table-cell]:text-[12px]"
            pagination={false}

          />
        </Spin>
      </div>
      <Pnation isNotShow={!isFullScreen} onPeding={onPeding} onCngPage={getData} url={'/dashboard/to_expire_agreement/'} plod={searchKeyword} itmeName={`${contract_type} Contracts`} />
      <Tooltip title={"Download Visible Contracts"}>
        {isFullScreen && <div className='flex justify-center'> <button
          onClick={handleDownloadAll}
          className="bg-[#36A34A] text-white py-[8px] px-[16px] text-[14px] mt-[40px] rounded-[5px] cursor-pointer"

        >
          Contracts Details <DownloadOutlined />
        </button> </div>}
      </Tooltip>
    </div>
  )
}
